import {Fragment, useEffect, useState} from "react"
import Text from "../../../../../core/utils/Text"
import { Background, CMargin, DeleteIcon, DText, Flex, IconWrapper, Padding } from "../../../../../styles/CommonStyles"
import { LineBreak } from "../../../../../styles/main/MainCommonStyles"
import { AddNetworkBtn } from "../../../../../styles/main/setting"
import Input from "../../../../common/input/Input"
import MotionFade from "../../../../common/utils/MotionFade"
import Tabbar from "../../../../common/tabs/Tabbar"
import Tooltip from "../../../../common/utils/Tooltip"
import ModalLayout from "../../../../layout/main/ModalLayout"
import AddNetworkModal from "../../../../modals/AddNetworkModal"
import CheckBox from "../../../../common/input/CheckBox";



const NetworkUpdate = ({
    coin,
    onDetailChange,
    onAddNetwork,
    onDeleteNetwork
}) => {

    const tabs = ['deposit', 'withdraw']
    const [activeTab, setActiveTab] = useState(1)
    const [addModal, setAddModal] = useState({type: null, open: false, coin: null})

    const onInputChange = (key, value, listIdx) => {
        const data = {
            key,
            value,
            listIdx,
            type: tabs[activeTab - 1]
        }
        onDetailChange(data)
    }

    const onModalOpen = () => setAddModal({open: true, type: tabs[activeTab - 1], coin})
    const onModalClose = () => setAddModal({type: null, open: false, coin: null})

    const addNetwork = (network) => {
        onModalClose()
        onAddNetwork(network, tabs[activeTab - 1])
    }

    return (
        <MotionFade>
            {coin &&
                <>
                    <CMargin margin='10px'/>
                    <Flex fw>
                        <Tabbar
                            active={activeTab}
                            tabs={tabs}
                            onTabClicked={(idx) => setActiveTab(idx)}
                        />

                        <AddNetworkBtn
                            onClick={onModalOpen}
                        >
                            <Flex fw fh>
                                <Text tid='add-network' />
                            </Flex>
                        </AddNetworkBtn>
                    </Flex>
                    {coin[tabs[activeTab - 1]]?.map((item, idx) => (
                        <Fragment key={idx}>
                            <CMargin margin='15px' />
                            <Flex fw justify={'space-between'}>
                                <DText main>
                                    {idx + 1} -
                                </DText>
                                <Tooltip
                                    content='delete-network'
                                >
                                    <IconWrapper
                                        onClick={() => onDeleteNetwork(idx, tabs[activeTab - 1])}
                                    >
                                        <DeleteIcon
                                            size={18}
                                        />
                                    </IconWrapper>
                                </Tooltip>
                            </Flex>
                            <Flex fw wrap justify='flex-start'>
                                <Background bg='detailBox'>
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.name}
                                        label={'name'}
                                        onInputChange={(v) => onInputChange('name', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.network}
                                        label={'network'}
                                        onInputChange={(v) => onInputChange('network', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.min}
                                        label={'min'}
                                        onInputChange={(v) => onInputChange('min', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                        currency={item.name}
                                        number
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.max}
                                        label={'max'}
                                        onInputChange={(v) => onInputChange('max', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                        currency={item.name}
                                        number
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.feeFactor}
                                        label={'fee-factor'}
                                        onInputChange={(v) => onInputChange('feeFactor', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                        number
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.feeMin}
                                        label={'fee-min'}
                                        onInputChange={(v) => onInputChange('feeMin', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                        currency={item.name}
                                        number
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.feeMax}
                                        label={'fee-max'}
                                        onInputChange={(v) => onInputChange('feeMax', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                        currency={item.name}
                                        number
                                    />
                                    <Input
                                        style={{ margin: '0 5px' }}
                                        size={'small'}
                                        value={item.delay}
                                        label={'delay'}
                                        onInputChange={(v) => onInputChange('delay', v, idx)}
                                        minWidth='180px'
                                        width='11%'
                                    />
                                    <Flex>
                                        <DText main fontSize={'s'} margin={'0 5px'}>
                                            <Text tid={'is-active'} /> :
                                        </DText>
                                        <CheckBox
                                            active={item.isActive}
                                            onClick={() => onInputChange('isActive', !item.isActive, idx)}
                                        />
                                    </Flex>
                                </Background>

                            </Flex>
                            <LineBreak />
                        </Fragment>
                    ))}
                </>
            }
            <ModalLayout
                width='480px'
                onClose={onModalClose}
                open={addModal.open}
            >
                <AddNetworkModal
                    details={addModal}
                    onCancel={onModalClose}
                    onSubmit={addNetwork}
                />
            </ModalLayout>
        </MotionFade>
    )
}


export default NetworkUpdate
